import { DataBundleWithActions, PagedCollectionBundle } from "@intocare/datatypes/lib/bundle";
import { KnownCodableConceptCode } from "@intocare/datatypes/lib/concept";

import { EvaluationMeasureType } from "./evaluation";
import { FollowUpPlanDetails, FollowUpPlanForSiteSummary, FollowUpPlanMeasure } from "./follow-up-plan";

interface BaseFollowUpPlanDetailsDto {
	id: string;
	residentId: string;
	title: string;
	problemStatement: string;
	followUpDate?: string;
	careThemes: KnownCodableConceptCode[];
	createdOn: string;
	createdBy: { label: string };
	measures?: FollowUpPlanMeasure[];
	version: number;
}

interface OpenFollowUpPlanDetailsDto extends BaseFollowUpPlanDetailsDto {
	status: "OPEN";
}

interface ClosedFollowUpPlanDetailsDto extends BaseFollowUpPlanDetailsDto {
	status: "CLOSED";
	closedOn: string;
	closedBy: { label: string };
}

export type FollowUpPlanDetailsDto = OpenFollowUpPlanDetailsDto | ClosedFollowUpPlanDetailsDto;

export const convertToFollowUpPlanDetails = (
	response: DataBundleWithActions<FollowUpPlanDetailsDto, "update">,
): DataBundleWithActions<FollowUpPlanDetails, "update"> => {
	return { ...response, data: { ...response.data, careTheme: response.data.careThemes[0] } };
};

export interface FollowUpPlanForSiteSummaryDto {
	id: string;
	residentId: string;
	title: string;
	problemStatement: string;
	followUpDate?: string;
	careThemes: KnownCodableConceptCode[];
	status: "OPEN" | "CLOSED";
	closedOn?: string;
	activeMeasureTypes: EvaluationMeasureType[];
}

export const convertToFollowUpPlanForSiteSummary = (
	response: PagedCollectionBundle<DataBundleWithActions<FollowUpPlanForSiteSummaryDto, never>>,
): PagedCollectionBundle<DataBundleWithActions<FollowUpPlanForSiteSummary, never>> => {
	return {
		...response,
		data: {
			...response.data,
			items: response.data.items.map(({ data: { careThemes, ...rest }, ...item }) => ({
				...item,
				data: { ...rest, careTheme: careThemes[0] },
			})),
		},
	};
};
